'use strict';

(function () {
  'use strict';

  angular.module('msActivityServices').service('seriesSvc', seriesSvc);

  seriesSvc.$inject = ['httpSvc'];

  /* @ngInject */
  function seriesSvc(httpSvc) {
    return {
      getSeriesActivities: getSeriesActivities,
      getProgram: getProgram
    };

    ////////////////

    function getSeriesActivities(series) {
      return httpSvc.get('/apiproxy/user/activities/programs/series/' + series.id).then(function (dat) {
        return dat.activities;
      });
    }

    function getProgram(id) {
      return httpSvc.get('/apiproxy/user/activities/programs/' + id);
    }
  }
})();